import React from 'react';
import Layout from '@components/layout/Layout';
import {
  getHomepageSections,
  shopifySectionToReact,
} from '@components/shopify/shopify-to-react';
import createOpenGraphTags from '@repo/utils/createOpenGraphTags';

const HomePage = () => {
  const homepageSections = getHomepageSections();
  const meta = createOpenGraphTags({}, 'kurgo');

  return (
    <Layout
      headTagData={{
        title: 'Kurgo: High Quality Outdoor Adventure Dog Gear Products',
        description:
          'Kurgo is a leading supplier of quality dog travel supplies, seat covers, harnesses & accessories for active dogs. Click to learn more about our dog accessories.',
        keywords:
          'Dog travel, dog outdoors, dog training, dog trip, dog car, dog hike',
        meta,
      }}
    >
      {Object.keys(homepageSections).map(sectionId =>
        shopifySectionToReact(sectionId, homepageSections[sectionId])
      )}
    </Layout>
  );
};

export default HomePage;
